

function ContentText({text}) 
{
  return ( <div>{text}</div> )
}

export default ContentText